import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as Nested from '../../utils/Nested';
import { fetchSearchById } from '../products/Products.state';

// Default State
const initialState = {
  error: false,
  isLoading: false,
};

// Action Creators and Action Types
export const SEND_SEARCH_REQUEST = 'SEND_SEARCH_REQUEST';
export const sendSearchRequest = (searchData) => ({
  type: SEND_SEARCH_REQUEST,
  payload: searchData,
});
export const SEARCH_REQUEST_SUCCESS = 'SEARCH_REQUEST_SUCCESS';
export const searchRequestSuccess = (searchData) => ({
  type: SEARCH_REQUEST_SUCCESS,
  payload: searchData,
});

const SEARCH_ERROR = 'search/SEARCH_ERROR';
export const searchError = (error) => ({
  type: SEARCH_ERROR,
  payload: { error },
});

// Alert Bar Nested Actions
export const ALERT_BAR_ACTION = 'search/ALERT_BAR_ACTION';
export const searchAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

// Raw Reducer
export const _reducer = (state = initialState, { type }) => {
  switch (type) {
    case SEND_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SEARCH_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
      };
    case SEARCH_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = (state) => ({
  ...state.search,
});
export const _mapDispatchToProps = (dispatch) => ({
  fetchSearchById: (id) => dispatch(fetchSearchById(id)),
  sendSearchRequest: (searchData) => dispatch(sendSearchRequest(searchData)),
});

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    alertBars: {
      searchAlertBars: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
  },
  'search',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
